import script from "./RotatingGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./RotatingGrid.vue?vue&type=script&setup=true&lang=js"

import "./RotatingGrid.vue?vue&type=style&index=0&id=a7f6a0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7f6a0f0"]])

export default __exports__